import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteContaCartaoCadastro } from '../service';
import {
  DELETE_CONTA_CARTAO_CADASTRO,
  DELETE_CONTA_CARTAO_CADASTRO_PENDING,
  DELETE_CONTA_CARTAO_CADASTRO_SUCCESS,
  DELETE_CONTA_CARTAO_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'

function* sagaDeleteContaCartaoCadastro(action) {
  yield put({ type: DELETE_CONTA_CARTAO_CADASTRO_PENDING, id: action.id })

  try {
    const a = yield call(deleteContaCartaoCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_CONTA_CARTAO_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_CONTA_CARTAO_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se a conta não possui vínculo com outra conta gerencial ou em lançamentos no financeiro.');
  }
}

export default function* watchDeleteContaCartaoCadastro() {
  yield takeLatest(DELETE_CONTA_CARTAO_CADASTRO, sagaDeleteContaCartaoCadastro)
}
